import { ELockUiStore } from 'sections/LKSection/modules/ELockModule/stores/ELockUiStore'
import { EmployeeELockRoleStore } from 'sections/LKSection/modules/EmployeeModule/stores/entity/EmployeeRole/EmployeeELockRole/EmployeeELockRoleStore'
import { EmployeeStore } from 'sections/LKSection/modules/EmployeeModule/stores/entity/EmployeeStore'
import { ViewEmployeeUiStore } from 'sections/LKSection/modules/EmployeeModule/stores/ViewEmployeeUiStore'
import { ActivateOrderUiStore } from 'sections/LKSection/modules/OrderModule/stores/ActivateOrder/ActivateOrderUiStore'
import { CreateOrderUiStore } from 'sections/LKSection/modules/OrderModule/stores/CreateOrder/CreateOrderUiStore'
import { OrderStore } from 'sections/LKSection/modules/OrderModule/stores/entity/OrderStore'
import { ViewOrderUiStore } from 'sections/LKSection/modules/OrderModule/stores/ViewOrder/ViewOrderUiStore'
import { PvzStore } from 'sections/LKSection/modules/PvzModule/stores/entity/PvzStore'
import { ViewPvzUiStore } from 'sections/LKSection/modules/PvzModule/stores/ViewPvz/ViewPvzUiStore'
import { CreateTicketUiStore } from 'sections/LKSection/modules/TicketModule/stores/CreateTicketUiStore'
import { TicketStore } from 'sections/LKSection/modules/TicketModule/stores/entity/TicketStore'
import { ViewTicketUiStore } from 'sections/LKSection/modules/TicketModule/stores/ViewTicket/ViewTicketUiStore'
import { LoginUiStore } from 'sections/LKSection/modules/UserModule/stores/LoginUiStore'
import { OfferUiStore } from 'sections/LKSection/modules/UserModule/stores/Offer/OfferUiStore'
import { ProfileUiStore } from 'sections/LKSection/modules/UserModule/stores/Profile/ProfileUiStore'
import { RegistrationUiStore } from 'sections/LKSection/modules/UserModule/stores/Registration/RegistrationUiStore'
import { SearchEngineUiStore } from 'sections/PromoSection/modules/SearchEngineModule/SearchEngineStore'

import { EmployeeRoleStore } from '../sections/LKSection/modules/EmployeeModule/stores/entity/EmployeeRole/EmployeeRoleStore'
import { AppStore } from '../shared/stores/AppStore'
import { IRootStore } from './types'

export interface IResettable {
  resetState(): void
}

class RootStore implements IRootStore, IResettable {
  constructor() {
    // store's
    this.appStore = new AppStore(this)
    this.orderStore = new OrderStore(this)
    this.pvzStore = new PvzStore(this)
    this.offerStore = new OfferUiStore(this)
    this.ticketStore = new TicketStore(this)
    this.employeeStore = new EmployeeStore(this)
    this.employeeRoleStore = new EmployeeRoleStore(this)
    this.employeeELockRoleStore = new EmployeeELockRoleStore(this)

    // uiStore's
    this.createOrderUiStore = new CreateOrderUiStore(this)
    this.activateOrderUiStore = new ActivateOrderUiStore(this)
    this.viewOrderUiStore = new ViewOrderUiStore(this)
    this.viewPvzUiStore = new ViewPvzUiStore(this)
    this.loginUiStore = new LoginUiStore(this)
    this.registrationUiStore = new RegistrationUiStore(this)
    this.eLockUiStore = new ELockUiStore(this)
    this.createTicketUiStore = new CreateTicketUiStore(this)
    this.viewTicketUiStore = new ViewTicketUiStore(this)
    this.searchEngineUiStore = new SearchEngineUiStore(this)
    this.profileUiStore = new ProfileUiStore(this)
    this.viewEmployeeUiStore = new ViewEmployeeUiStore(this)
  }

  // store's
  readonly appStore: AppStore
  readonly orderStore: OrderStore
  readonly pvzStore: PvzStore
  readonly offerStore: OfferUiStore
  readonly ticketStore: TicketStore
  readonly employeeStore: EmployeeStore
  readonly employeeRoleStore: EmployeeRoleStore
  readonly employeeELockRoleStore: EmployeeELockRoleStore

  // uiStore's
  readonly createOrderUiStore: CreateOrderUiStore
  readonly activateOrderUiStore: ActivateOrderUiStore
  readonly viewOrderUiStore: ViewOrderUiStore
  readonly viewPvzUiStore: ViewPvzUiStore
  readonly loginUiStore: LoginUiStore
  readonly registrationUiStore: RegistrationUiStore
  readonly eLockUiStore: ELockUiStore
  readonly createTicketUiStore: CreateTicketUiStore
  readonly viewTicketUiStore: ViewTicketUiStore
  readonly searchEngineUiStore: SearchEngineUiStore
  readonly profileUiStore: ProfileUiStore
  readonly viewEmployeeUiStore: ViewEmployeeUiStore

  private get resettable(): IResettable[] {
    return []
  }

  resetState(): void {
    this.resettable.forEach((r) => r.resetState())
  }
}

export const rootStore = new RootStore()
